import React, { PureComponent } from 'react';
let DateTimeField = require('react-bootstrap-datetimepicker');
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class FechaValor extends PureComponent {
    constructor(props) {
        super(props);
        this.changeDate = this.changeDate.bind(this);
    }

    changeDate(rule, date, callback) {
        if (date != "Invalid date") {
            const fechaFormateada = GlobalHelper.FormatDate(this.props.ingresoCobranza.fechaCobranza.toString().slice(0, 19).replace('T', ' '));
            const fechaFormateadaHoy = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
            if(!date){
                date = fechaFormateadaHoy;
            }
            let resultado = GlobalHelper.CompararIntervaloFechaDeHoy(date, fechaFormateada);
            if (resultado.estado) {
                let dateParts = date.split("/");
                let newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                this.props.changeDate(newDate);
                callback();
            } else {
                callback("Debe seleccionar una fecha entre el " + fechaFormateada + " y " + fechaFormateadaHoy + ".");
            }
        }
        else {
            callback("Fecha inválida.");
        }
    }

    render() {
        const { ingresoCobranza, form } = this.props;
        const { getFieldDecorator, getFieldError } = form;

        let errors;
        let errorContainer = <label className="error">
        {(errors = getFieldError('fechaValor')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('fechaValor')) ? true : false);

        let fechaCobranzaFormato = ingresoCobranza.fechaCobranza ? GlobalHelper.FormatDate(ingresoCobranza.fechaCobranza.toString().slice(0, 19).replace('T', ' ')) : "-"

        let defaultText;

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Fecha Valor</label>
                      {getFieldDecorator('fechaValor', {
                        rules: [ {
                          validator: this.changeDate,
                        }],
                      })(                    
                        <DateTimeField
                            mode="date"
                            defaultText={defaultText}
                            dateTime={ingresoCobranza.fechaValor}
                            format={"DD/MM/YYYY"}
                            inputFormat={"DD/MM/YYYY"}
                        />
                      )}
                    {error && errorContainer}
                </div>
            </div>
        );
    }
};

export default FechaValor;